// Author YuJiaBei
// Date 2020-07-13 14:07:16

import * as model from "@/model/em/admin/EmMenuModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

let userAclsAndRoles = null
//尝试获取缓存，防止刷新时把vuex中的值刷没了
try {
    if (localStorage.em_userAclsAndRoles) {
        userAclsAndRoles = JSON.parse(localStorage.em_userAclsAndRoles)
    }
} catch (e) {
    console.log("获取localStorage失败，请检查是否禁用了本地缓存，或设置了无痕上网")
}

export default newEntityStoreHelper(() => new model.EmMenu(), newFilter)
    .withStates({
        userAclsAndRoles,
        baseModuleUrl: process.env.VUE_APP_EM_ADMIN_URL,
        routerCards: [],
        editCards: [],
        newNotification:null
    })
    .withActions({
        retrieveForUserAclsAndRoles(context) {
            context.dispatch("api/get", {
                url: (context.state.baseModuleUrl + "/emMenu/user-acl")
            }, {root: true})
                .then(function (data) {
                    context.commit("emMenu/setUserAclsAndRoles", data, {root: true})
                })
        },
        retrieveForRouterCards(context, menuId) {
            context.dispatch("api/get", {
                url: (context.state.baseModuleUrl + "/emMenu/routerCardList/" + menuId)
            }, {root: true})
                .then(function (data) {
                    context.commit("emMenu/setRouterCardList", data, {root: true})
                })
        },
        retrieveForEditCards(context, menuId) {
            context.dispatch("api/get", {
                url: (context.state.baseModuleUrl + "/emMenu/editCardList/" + menuId)
            }, {root: true})
                .then(function (data) {
                    context.commit("emMenu/setEditCardList", data, {root: true})
                })
        }
    })
    .withMutations({
        setUserAclsAndRoles(state, data) {
            state.userAclsAndRoles = data
            //同时设置缓存，缓存的清除只在keycloakAdapter中增加了，登出时清空此缓存的代码
            //关闭浏览器时，清空此缓存的代码先暂时不写了。影响不大，写了也还挺费劲。
            // 需要在主vue对象中的mounted中添加一个监听，类似下面这样的代码
            // window.addEventListener('beforeunload',()=>{
            //     localStorage.removeItem('token');
            // });
            // 但这样就连刷新时也会清空了，一个解决思路是同时添加一个cookie，因为浏览器关闭时会清空cookie，所以判断是否删除缓存时，先判断一下有没有相同的cookie就可以了
            // 由于还挺麻烦，所以就先不弄了。
            try {
                localStorage.em_userAclsAndRoles = JSON.stringify(data)
            } catch (e) {
                console.log("设置localStorage失败，请检查是否禁用了本地缓存，或设置了无痕上网")
            }
        },
        setRouterCardList(state, data) {
            state.routerCards = data
        },
        setEditCardList(state, data) {
            state.editCards = data
        },
        setNewNotification(state, data) {
            state.newNotification = data
        }
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'emMenu',
        modelFilter: model.filter
    })
    .buildStore()
